import { object } from "prop-types"
import { AlertMessage } from "source/shared/AlertMessage"
import useQueryString from "source/hooks/useQueryString"

const Alert = ({ registration }) => {
  const [params] = useQueryString()

  const requiredQuestionIds = registration.questions
    .filter((question) => question.required)
    .map((question) => question.id)

  const answeredQuestionIds = registration.answers.map(
    (answer) => answer.questionId,
  )

  const allQuestionsAnswered = requiredQuestionIds.every((questionId) =>
    answeredQuestionIds.includes(questionId),
  )

  const newRegistrationUrl = `${registration.event.newRegistrationUrl}${
    params.source ? `?source=${params.source}` : ""
  }`

  return (
    <>
      {registration.canceledOn ? (
        <AlertMessage type="info" icon="general#info-circle">
          This registration has been cancelled. Do you need to{" "}
          <a href={newRegistrationUrl}>register again</a>?
        </AlertMessage>
      ) : (
        <>
          {!allQuestionsAnswered && (
            <AlertMessage type="warning" icon="general#exclamation-triangle">
              Additional information is required to complete your registration.
            </AlertMessage>
          )}
        </>
      )}
    </>
  )
}

Alert.propTypes = {
  registration: object,
}

export default Alert
